import { styled } from "@mui/material/styles";
import { Tabs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import HourAvailable from "./HourAvailable";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  showModalReservationState,
  hourSelectedState,
  professionalSelectedState,
} from "src/store/reservation/reservationState";
import { agendamientoInconclusoState } from "src/ResultSearch/state/atoms";
import { userState } from "src/store/user/userState";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";
import { valuesFormReservationGuestState } from "src/Patient/state/atoms";
import { cleanRut } from "src/shared/global/helpers";

const StyledTabs = styled((props) => <Tabs {...props} />)(({ theme }) => ({
  width: "100%",
  "& .MuiTabs-scrollButtons": {
    display: "inherit",
  },
  ".Mui-disabled": {
    display: "none",
  },
  ".MuiButtonBase-root": {
    opacity: 1,
    minWidth: 72,
  },
}));

const ListHoursAvailables = ({ professional }) => {
  const [, setShowModal] = useRecoilState(showModalReservationState);
  const [, setHourSelected] = useRecoilState(hourSelectedState);
  const [, setProfessionalSelected] = useRecoilState(professionalSelectedState);
  const setAgendamientoInconcluso = useSetRecoilState(
    agendamientoInconclusoState
  );

  const handleClickOpenModalReservation = (el) => (ev) => {
    setAgendamientoInconcluso((prev) => ({
      ...prev,
      ptdRut: el.professional.ptdRut.trim(),
      agpCorrel: el.professional.agpCorrel,
    }));

    setHourSelected(el);
    setProfessionalSelected(el);
    setShowModal(true);
    console.log(el);
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <StyledTabs
        value={false}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="styled tabs example"
      >
        {professional.horas.map((el) => {
          if (el.ageInicio == "00:00") {
            return (
              <Box
                key={`${el.ageCorrel}_${el.ageInicio}`}
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  paddingTop: "12px",
                  width: "100%",
                  color: "#288FF9",
                }}
              >
                <Typography variant="button" display="block" gutterBottom>
                  {process.env.REACT_APP_FONO}
                </Typography>
              </Box>
            );
          } else {
            return (
              <HourAvailable
                click={handleClickOpenModalReservation({
                  professional,
                  hourSelected: el,
                })}
                key={`${el.ageCorrel}_${el.ageInicio}`}
                hour={el.ageInicio}
              />
            );
          }
        })}
      </StyledTabs>
    </Box>
  );
};

export default ListHoursAvailables;
